import cogoToast from "cogo-toast";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { socket, UploadApi } from "../../constants/Constants";
import Auth from "../Auth/Auth";
import Auth2 from "../Auth/Auth2";
import Dashboard from "../Dashboard/Dashboard";
import axios from "axios";
import { persistor } from "../../app/store";
import { logoutUser } from "../../app/features/counterSlice";

const Routers = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const folderName = useSelector((state) => state.FolderGet.FolderName);

  async function getCurrentUser() {
    try {
      const token = localStorage.getItem("token");
      if (!token) throw new Error("No token found");

      const response = await axios.get(`${UploadApi}/user/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status !== 200) {
        handleSessionExpired();
      }
    } catch (error) {
      handleSessionExpired();
    }
  }

  function handleSessionExpired() {
    persistor.purge();
    dispatch(logoutUser());
    cogoToast.error("Session timed out, please log in again.", {
      position: "top-right",
    });
    window.location.href = "/signin";
  }

  useEffect(() => {
    const currentUrl = window.location.href;
    if (!currentUrl.includes("signin")) getCurrentUser();
  }, []);

  useEffect(() => {
    if (folderName) {
      let roomId = folderName;
      if (folderName.includes("/")) {
        roomId = folderName.split("/")[0];
      }
      socket.emit("join-room", roomId);
    }

    const handleNotification = () => {
      cogoToast.info(
        `Folder has been updated. Please view activity logs for all details.`,
        { position: `top-right`, hideAfter: 5 }
      );
    };

    socket.on("notification-received", handleNotification);

    return () => {
      socket.off("notification-received", handleNotification);
    };
  }, [folderName]);

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          exact
          element={user ? <Dashboard /> : <Navigate to="/signin" />}
        />
        <Route
          path="/signin/:email/:pass/:date/:FolderName"
          exact
          element={<Auth />}
        />
        <Route
          path="/signin/:email/:pass/:date/"
          exact
          element={user ? <Navigate to="/" /> : <Auth />}
        />
        <Route
          path="/signin"
          exact
          element={user ? <Navigate to="/" /> : <Auth2 />}
        />
        {/* For Study Table Filtered */}
        <Route
          path="/StudyTable/:modality/:FolderName"
          element={<Dashboard />}
        />
        {/* Done */}
        <Route
          path="/StudyTable/:FolderName/:modality/:subFolder"
          element={<Dashboard />}
        />
        <Route
          path="/StudyTable/:FolderName/:modality/:subFolder/:thirdFolder"
          element={<Dashboard />}
        />
        <Route
          path="/StudyTable/:FolderName/:modality/:subFolder/:thirdFolder/:fourthFolder"
          element={<Dashboard />}
        />
        {/* Done */}
        {/* For Upload file and Document  */}
        <Route
          path="/Upload/:FolderName/:modality/:ssuid"
          element={<Dashboard />}
        />{" "}
        {/* Done */}
        <Route
          path="/Upload/:FolderName/:subFolder/:modality/:ssuid"
          element={<Dashboard />}
        />
        <Route
          path="/Upload/:FolderName/:subFolder/:thirdFolder/:modality/:ssuid"
          element={<Dashboard />}
        />
        <Route
          path="/Upload/:FolderName/:subFolder/:thirdFolder/:fourthFolder/:modality/:ssuid"
          element={<Dashboard />}
        />
        {/* Done */}
        {/* For Sub or Child and Studies */}
        <Route
          path="/SubFolder&studies/:FolderName"
          element={<Dashboard />}
        />{" "}
        {/* Done */}
        <Route
          path="/SubFolder&studies/:FolderName/:subFolder"
          element={<Dashboard />}
        />{" "}
        <Route
          path="/SubFolder&studies/:FolderName/:subFolder/:thirdFolder"
          element={<Dashboard />}
        />{" "}
        <Route
          path="/SubFolder&studies/:FolderName/:subFolder/:thirdFolder/:fourthFolder"
          element={<Dashboard />}
        />{" "}
        {/* Done */}
        <Route
          path="/signin/:Foldername"
          exact
          element={user ? <Navigate to="/" /> : <Auth />}
        />
        <Route
          path="/signin/:user1"
          exact
          element={user ? <Navigate to="/" /> : <Auth />}
        />
      </Routes>
    </BrowserRouter>
  );
};

export default Routers;
